export enum FileUploadProgressTypes {
    LOADING,
    UPLOADING,
    PROCESSING,
    ERROR,
    FINISHED,
  }
  
  export interface FileUploadProgressStatus {
    status: FileUploadProgressTypes;
    progress?: number;
  }
  
  export type UploadProgress<T> = FileUploadProgressStatus & {data?: T};
  
  export interface FileDto {
    errorMessages?: any;
    id?: number;
    name: string;
    file?: string;
    url?: string;
    mimeType?: string;
    fileLength?: number;
  }
